/* eslint-disable @typescript-eslint/ban-ts-comment */
export const createWorker = () =>
  new Worker(
    // @ts-ignore
    new URL('./events.flow.worker.ts', import.meta.url),
  );
